<template>
	<el-form ref="form">
		<el-form-item>
			<el-input
				v-model="post.username"
				prefix-icon="el-icon-user"
				placeholder="用户名或手机号"
				@keyup.enter.native="login"
			></el-input>
		</el-form-item>
		<el-form-item>
			<el-input
				v-model="post.password"
				prefix-icon="el-icon-lock"
				placeholder="登录密码"
				@keyup.enter.native="login"
				show-password
			></el-input>
			<el-row :gutter="0">
				<el-col :span="12">
					<el-checkbox v-model="post.remember">记录密码</el-checkbox>
				</el-col>
				<el-col :span="12" align="right">
					<a href @click.prevent="forgetPassword">忘记密码？</a>
				</el-col>
			</el-row>
		</el-form-item>
		<el-form-item class="el-form-action">
			<el-button type="primary" @click.prevent="login" :loading="loading">立即登录</el-button>
			<el-button type="default" @click.prevent="wechatLogin" class="wechat">
				<i class="fa fa-wechat"></i>
				使用微信登录
			</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
export default {
	name: "Login",
	data() {
		return {
			loading: false,
			post: {
				username: "",
				password: "",
				remember: true
			}
		};
	},
	methods: {
		login() {
			this.loading = true;
			this.axios
				.post(this.axios.apiGateway + "user/login", this.post)
				.then(res => {
					this.$message.closeAll();
					this.loading = false;
					if (res.data.errcode) {
						this.$message({
							type: "error",
							message: res.data.errmsg
						});
					} else {
						this.$notify({
							title: "登录成功",
							message: "Hi," + res.data.nickname + "! 欢迎回来。",
							type: "success"
						});

						this.$store.dispatch("login", res.data);
						this.$parent.hide && this.$parent.hide();
					}
				});
		},
		wechatLogin() {
			// this.$message("暂未接入微信");
			window.open(this.axios.apiGateway+'user/oauthlogin', 'oauth', 'width=760,height=540', true);
		},
		forgetPassword() {
			this.util.$emit("forgetPassword");
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Passport/Login.vue